import { environment } from './../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CFETILMEndpointsConstant } from '../constants/cfet-ilm-endpoints.constant';

@Injectable({
    providedIn: 'root'
})
export class CfetService {
    public responseHeader: any;
    public responseHeader1: any;
    public responsePostHeader: any;
    public globResponse: any;
    public globResponse1: any;
    public globPostResponse: any;
    public cfetLiveGetResponse: any;
    public cfetLivePostResponse: any;
    public cfetPostResponse: any;
    public cfetDeleteResponse: any;
    public cfetPutResponse: any;
    public utfGlobResponse: any;
    public pwdObj: any = { pdRules: [], currentPassword: [], isErrorCodeArray: [] };
    ruleHeaders = ['lengthRule', 'capitalLetterRule', 'smallLetterRule', 'numRule', 'specialCharsRule'];
    public config = {
        // Default value for Header
        headers: {
            'Content-Type': 'application/json'
        }
    };
    isLandingPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    trapFocus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _securityQuestions: Array<any>;
    private _statesList: Array<any>;
    private _timeZones: Array<any>;
    private _validSPATerritories: Array<any>;

    /*  making variables readonly to avoid overwriting in other locations. */
    public get securityQuestions() { return this._securityQuestions; }
    public get statesList() { return this._statesList; }
    public get timeZones() { return this._timeZones; }
    public get validSPATerritories() { return this._validSPATerritories; }

    constructor(private http: HttpClient, private titleService: Title, private router: Router) { }
    setHtmlTitle(cfettitle: string) {
        this.titleService.setTitle(cfettitle);
    }

    cfetLiveGetHeader(requestParam, restUrlData, oConfig): Observable<any> {
        const newHeader = { ...this.config, ...oConfig };
        const url = environment.getApiLiveUrl();
        return this.http.get(`${url}${restUrlData}`, {
            observe: 'response', responseType: 'text', headers: newHeader
        }).pipe(map((response: HttpResponse<any>) => {
            this.responseHeader1 = response.headers;
            this.cfetLiveGetResponse = {};
            this.cfetLiveGetResponse.userDetails = JSON.parse(response.body);
            this.cfetLiveGetResponse.userHeaders = {};
            console.log(this.responseHeader1.lazyInit()); // Do not remove this line
            const headerKeys = this.responseHeader1.keys();
            headerKeys.forEach(key => {
            this.cfetLiveGetResponse.userHeaders[key] =
            this.responseHeader1.get(key);
    });
            return this.cfetLiveGetResponse;
        },
            error => {
                console.log(`cfetLiveGetHeader error  ${error}`);
                return throwError(error);
            }));
    }

     cfetLivePostHeader(requestParam, restUrlData, oConfig): Observable<any> {
        const url = environment.getApiLiveUrl();
        let headersObj = { ...(this.config?.headers || {}) };
        if (oConfig) {
            if (!(oConfig instanceof HttpHeaders)) {
                headersObj = { ...headersObj, ...oConfig };
            }
        }
        const headers = new HttpHeaders(headersObj);
        return this.http.post(`${url}${restUrlData}`, requestParam, {
            observe: 'response',
            responseType: 'text',
            headers: headers   // ✅ FIXED
        }).pipe(map((response: HttpResponse<any>) => {
                this.responsePostHeader = response.headers;
                this.cfetLivePostResponse = {};
                this.cfetLivePostResponse.userDetails = JSON.parse(response.body);
                this.cfetLivePostResponse.userHeaders = {};
                const headerKeys = this.responsePostHeader.keys();
                headerKeys.forEach(key => {
                this.cfetLivePostResponse.userHeaders[key] =
                    this.responsePostHeader.get(key);
                });
                return this.cfetLivePostResponse;
            }),
            catchError((error) => {
                console.log('cfetLivePostHeader error', error);
                return throwError(error);
            })
        );
    }

    cfetDelete(restUrlData): Observable<any> {
        const url = environment.getApiLiveUrl();
        return this.http.delete(`${url}${restUrlData}`, this.config).pipe(map(response => {
            this.cfetDeleteResponse = response;
            return this.cfetDeleteResponse;
        },
            error => {
                console.log(`cfetDelete error  ${error}`);
                return throwError(error);
            }));
    }

    cfetLivePut(requestParam, restURL): Observable<any> {
        const url = environment.getApiLiveUrl();
        return this.http.put(`${url}${restURL}`, requestParam).pipe(map(response => {
            this.cfetPutResponse = response;
            return this.cfetPutResponse;
        },
            error => {
                console.log(`cfetLivePut error  ${error}`);
                return throwError(error);
            }));
    }

    cfetLivePost(requestParam, restUrlData): Observable<any> {
        const url = environment.getApiLiveUrl();
        // eslint-disable-next-line max-len
        console.log("cfetLivePost - appDevFlag = ", environment.appDevFlag);
        return this.http.post(`${url}${restUrlData}`, requestParam, this.config).pipe(map(response => {
            this.cfetPostResponse = response;
            return this.cfetPostResponse;
        },
            error => {
                console.log(`cfetLiveGet error  ${error}`);
                return throwError(error);
            }));
    }
    
    utfHeader(): Observable<any> {
        const url = location.href;
        return this.http.get(url, { observe: 'response', responseType: 'text' }).pipe(map((response: HttpResponse<any>) => {
            this.responseHeader = response.headers;
            console.log(this.responseHeader.lazyInit()); // Do not remove this line
            return this.loadHeader(this.responseHeader);
        },
            error => {
                console.log(`utfAMattributes error  ${error}`);
                return throwError(error);
            }));
    }
    loadHeader(response) {
        // On success store the headers in AMHeaders
        console.log(`httpHeaders ${response.headers}`);
        this.globResponse = response.headers;
        const headerKeys = this.globResponse.keys();
        const AMheaders: any = {};
        headerKeys.forEach(key => {
            AMheaders[key] = this.globResponse.get(key);
        });
        if (AMheaders && AMheaders['xuserid'] && AMheaders['xuserid'].indexOf('@slid.dum') !== -1) {
            AMheaders['xuserid'] = AMheaders['xuserid'].substr(0, AMheaders['xuserid'].indexOf('@slid.dum'));
        }
        sessionStorage.setItem('ngStorage-AMUTFHeaders', JSON.stringify(AMheaders));
        return AMheaders;
    }

    // cfetLoadFederatedAttributes service
    cfetLoadFederatedAttributes(): Observable<any> {
        return this.http.get(`${environment.getApiLiveUrl()}attribute/v5/list/attribute_ids/${environment.companyId}/Federated_Identity`,
            this.config)
            .pipe(map(response => {
                return this.loadFederatedAttributes(response);
            },
                error => {
                    console.log(`cfetLoadFederatedAttributes error ${error}`);
                    return throwError(error);
                }));
    }

    loadFederatedAttributes(data) {
        const cfetAttributes = {};
        // Get cal for federated attributes
        data.attributes.forEach(element => {
            cfetAttributes[element.attribute_name] = element.attribute_id;
        });
        // Storing entitlements
        data.entitlements.forEach(element => {
            if (!cfetAttributes.hasOwnProperty(element.attribute_name)) {
                cfetAttributes[element.attribute_name] = element.attribute_id;
            }
        });
        return cfetAttributes;
    }

    // cfetLoadNonFederatedAttributes service
    cfetLoadNonFederatedAttributes(): Observable<any> {
        // Get cal for non federated attributes
        return this.http.get(`${environment.getApiLiveUrl()}attribute/v5/list/attribute_ids/${environment.companyId}/identity`, this.config)
            .pipe(map(response => {
                return this.loadNonFederatedAttributes(response);
            },
                error => {
                    console.log(`cfetLoadNonFederatedAttributes error  ${error}`);
                    return throwError(error);
                }));
    }

    loadNonFederatedAttributes(data) {
        const cfetNonfedAttributes = {};
        // Get cal for federated attributes
        data.attributes.forEach(element => {
            cfetNonfedAttributes[element.attribute_name] = element.attribute_id;
        });
        // looping through entitlements
        data.entitlements.forEach(element => {
            if (!cfetNonfedAttributes.hasOwnProperty(element.attribute_name)) {
                cfetNonfedAttributes[element.attribute_name] = element.attribute_id;
            }
        });
        return cfetNonfedAttributes;
    }

    cfetLoadFederatedOrNonFederatedAttributes(data) {
        const isUserFederated = data && data.isUserFederated ? data.isUserFederated : false;
        if (isUserFederated) {
            return this.cfetLoadFederatedAttributes();
        } else {
            return this.cfetLoadNonFederatedAttributes();
        }
    }

    cfetLiveGet(requestParam, restUrlData) {
        let cfetGetResponse;
        const url = environment.getApiLiveUrl();
        return this.http.get(`${url}${restUrlData}`, this.config).pipe(map(response => {
            cfetGetResponse = response;
            return cfetGetResponse;
        },
            error => {
                console.log(`cfetLiveGet error  ${error}`);
                return throwError(error);
            }));
    }

    cfetLiveNodmainGet(requestParam, restUrlData) {
        let cfetGetResponse;
        return this.http.get(`${restUrlData}`, this.config).pipe(map(response => {
            cfetGetResponse = response;
            return cfetGetResponse;
        },
            error => {
                console.log(`cfetLiveGet error  ${error}`);
                return throwError(error);
            }));
    }

    cfetLiveGetNocache(requestParam, restUrlData) {
        let cfetGetResponse;
        const url = environment.getApiLiveUrl();
        const cacheheaders = {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }
        };
        const combinedconfig = { headers: { ...cacheheaders.headers, ...this.config.headers } };
        return this.http.get(`${url}${restUrlData}`, combinedconfig).pipe(map(response => {
            cfetGetResponse = response;
            return cfetGetResponse;
        },
            error => {
                console.log(`cfetLiveGet error  ${error}`);
                return throwError(error);
            }));
    }

    cfetLoadOrgAttributes(): Observable<any> {
        const cfetAttributes = {};
        const url = `${environment.getApiLiveUrl()}${CFETILMEndpointsConstant.GET_ORGANIZATION_ATTRIBUTES}`;
        return this.http.get(url, this.config).
            pipe(map(data => {
                data['attributes'].forEach(val => {
                    cfetAttributes[val.attribute_name] = val.attribute_id;
                });
                return cfetAttributes;
            }
            ));
    }

    // converDateFormat function
    convertToDateFormat(reviewdDTS, hasTimeFromApi) {
        const formatTwoDigit = { '1': '01', '2': '02', '3': '03', '4': '04', '5': '05', '6': '06', '7': '07', '8': '08', '9': '09' };
        const formatDate = [];
        let month = (reviewdDTS.getUTCMonth() + 1).toString();
        if (month.length === 1) {
            month = formatTwoDigit[month];
        }
        let date = (hasTimeFromApi) ? reviewdDTS.getDate().toString() : reviewdDTS.getUTCDate().toString();
        if (date.length === 1) {
            date = formatTwoDigit[date];
        }
        let year = reviewdDTS.getUTCFullYear().toString();
        formatDate.push(month);
        formatDate.push(date);
        formatDate.push(year);
        return formatDate.join('/');
    }

    removingDuplicates(arrayList) {
        const output = [];
        const keys = [];
        arrayList.forEach((item) => {
            const key = item['roleId'];
            if (keys.indexOf(key) === -1) {
                keys.push(key);
                output.push(item);
            }
        });
        return output;
    }

    clearPasswordErrors() {
        this.pwdObj.pdRules[0] = {};
        for (let rule of this.ruleHeaders) {
            this.pwdObj.pdRules[0][rule] = false;
        }
    }

    getCommonList(): Observable<any> {
        const url = `${environment.getApiLiveUrl()}${CFETILMEndpointsConstant.GET_COMMON_LIST}`+ (environment.companyId);
        console.log('getCommonList: url =', url);
        console.log('Inside company Get Profile', url);
        return this.http.get<any>(url).pipe(
            map(profile => {
                this._statesList = profile['validStates'];
                this._validSPATerritories = profile['validSPATerritories'];
                this._timeZones = profile['validTimeZones'];
                this._securityQuestions = profile['securityQuestions'];
                sessionStorage.setItem('ngStorage-commonListValues', JSON.stringify(profile));
                return profile;
            }),
            catchError(error => {
                console.log(error);
                this.router.navigate(['error'], { queryParams: { code: '404' } });
                return throwError(() => error);
            })
        );
    }
}
